import styled from 'styled-components';
import { BREAKPOINTS } from "../../../../app/appConstants";

export const ConfirmLinkWrapperStyled = styled.div`
    button {
        color: var(--color-white);
    }
`;

export const ConfirmEmailCodeInputStyled = styled.input`
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--color-base);
    width: 62px;
    height: 64px;
    text-align: center;
    font-weight: 400;
    font-size: 24px;
    color: var(--color-white);
    border-radius: 20px !important;
    padding: 0 !important;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -moz-appearance: textfield;
    &, &:hover, &:focus, &:active {
        border-color: var(--color-base);;
    }
    
    &.is-invalid {
        &, &:hover, &:focus, &:active {
            color: #FF858B;
            border-color: #FF858B;
            background-color: rgba(255, 100, 108, 0.2);;
        }
    }
`;

export const ConfirmButtonWrapperStyled = styled.div`
    svg {
        fill: var(--color-yellow);
    }
    button:hover, button:active, button:focus {
        text-decoration: none;
        ${({ black }) => black && 'color: var(--color-purple-highlight)'};
        svg {
            fill: var(--color-white);
        }
    }
`;

export const ConfirmErrorContainer = styled.div`
    max-width: 300px;
    margin: 0 auto;
    color: #FF858B;
`;

export const ConfirmChangeEmailButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 12px 0 32px;
`;

export const ConfirmVerifyCodeHeaderStyled = styled.h1`
    font-size: 40px;
    @media(max-width: ${BREAKPOINTS.medium}px) {
        font-size: 32px;
    }
`;

export const ConfirmChangeEmailTooltipContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    width: 320px;
    transform: translateX(-22px);
`;

export const ConfirmChangeEmailTooltipStyled = styled.div`
    background-color: var(--color-base);
    color: var(--text-color-secondary);
    font-size: 16px;
    border-radius: 2px;
    padding: 4px 8px;
    text-align: center;
`;

export const ConfirmSpamDescriptionStyled = styled.p`
    margin: 16px auto;
    text-align: center;
    max-width: 343px;
    color: var(--color-secondary);
`;
